import ProjectNotificationCompanySettingsPage from './ProjectNotificationCompanySettings.vue'

/** 会社全体通知設定画面のルーター互換ラッパー。 */
export default ProjectNotificationCompanySettingsPage
